import { render, staticRenderFns } from "./AuxiliaryAccountingDetail.vue?vue&type=template&id=50de92be&scoped=true"
import script from "./AuxiliaryAccountingDetail.vue?vue&type=script&lang=js"
export * from "./AuxiliaryAccountingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de92be",
  null
  
)

export default component.exports